export default {
  MuiAccordion: {
    root: {
      border: [1, 'solid', '#CFD8DC'],
      borderRadius: '0px',
      boxShadow: 'none',
      '&:before': {
        height: '0px',
      },
      '&$expanded': {
        margin: '0px',
      },
      '&:not(:last-child)': {
        borderBottom: 0,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Accordian.js